<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row no-gutters>
        <image-row :title="topTitle" config="page-rd" />
      </v-row>
      <div class="lab-wrapper">
        <div class="lab-content">
          <div class="lab-title-wrapper">
            <span class="lab-title">{{ labTitle }}</span>
          </div>
          <div class="lab-first-text-wrapper">
            <span class="lab-first-text">{{ labFirstText }}</span>
          </div>
          <div class="lab-second-text-wrapper">
            <span class="lab-second-text">{{ labSecondText }}</span>
          </div>
        </div>
      </div>
      <v-row v-if="!isMobile" no-gutters justify="center" class="lab-cards-wrapper-parent">
        <div class="lab-cards-wrapper-child">
          <v-card class="lab-card first-child">
            <v-img eager src="https://storage.googleapis.com/mwm-website-v2-content/rd/card-mixfader.jpg" />
            <div class="lab-first-card-content-wrapper">
              <div class="lab-first-card-title-wrapper">
                <div class="lab-first-card-title">
                  <span class="title-accent">{{ firstCardTitleAccent }}</span><br/>
                  {{ firstCardTitle }}
                </div>
              </div>
              <div class="lab-card-quote-wrapper">
                <div>
                  <img class="lab-card-quotemark quotemark-topleft" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                  <span class="lab-card-quote">{{ firstCardQuote1Quote }}</span>
                  <img class="lab-card-quotemark quotemark-botright" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                </div>
                <div class="lab-card-quoter-wrapper"><span class="lab-card-quoter">{{ firstCardQuote1Quoter }}</span></div>
              </div>
              <div class="lab-card-quote-wrapper">
                <div>
                  <img class="lab-card-quotemark quotemark-topleft" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                  <span class="lab-card-quote">{{ firstCardQuote2Quote }}</span>
                  <img class="lab-card-quotemark quotemark-botright" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                </div>
                <div class="lab-card-quoter-wrapper"><span class="lab-card-quoter">{{ firstCardQuote2Quoter }}</span></div>
              </div>
              <div class="lab-card-button-wrapper">
                <v-btn height="54" :ripple="false" class="lab-card-button" @click="openUrl(firstCardURL)">
                  <span class="lab-card-button-text">{{ cardButtonText }}</span>
                </v-btn>
              </div>
            </div>
          </v-card>
          <v-card class="lab-card second-child">
            <v-img eager src="https://storage.googleapis.com/mwm-website-v2-content/rd/card-phase.jpg" />
            <div class="lab-second-card-content-wrapper">
              <div class="lab-second-card-title-wrapper">
                <div class="lab-second-card-title">
                  <span class="title-accent">{{ secondCardTitleAccent }}</span><br/>
                  {{ secondCardTitle }}
                </div>
              </div>
              <div class="lab-card-quote-wrapper">
                <div>
                  <img class="lab-card-quotemark quotemark-topleft" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                  <span class="lab-card-quote">{{ secondCardQuote1Quote }}</span>
                  <img class="lab-card-quotemark quotemark-botright" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                </div>
                <div class="lab-card-quoter-wrapper"><span class="lab-card-quoter">{{ secondCardQuote1Quoter }}</span></div>
              </div>
              <div class="lab-card-quote-wrapper">
                <div>
                  <img class="lab-card-quotemark quotemark-topleft" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                  <span class="lab-card-quote">{{ secondCardQuote2Quote }}</span>
                  <img class="lab-card-quotemark quotemark-botright" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                </div>
                <div class="lab-card-quoter-wrapper"><span class="lab-card-quoter">{{ secondCardQuote2Quoter }}</span></div>
              </div>
              <div class="lab-card-button-wrapper">
                <v-btn height="54" :ripple="false" class="lab-card-button" @click="openUrl(secondCardURL)">
                  <span class="lab-card-button-text">{{ cardButtonText }}</span>
                </v-btn>
              </div>
            </div>
          </v-card>
          <v-card class="lab-card third-child">
            <v-img eager src="https://storage.googleapis.com/mwm-website-v2-content/rd/card-audio.jpg" />
            <div class="lab-third-card-content-wrapper">
              <div class="lab-third-card-title-wrapper">
                <span class="lab-third-card-title">{{ thirdCardTitle }}</span>
              </div>
              <div class="lab-third-card-text-wrapper">
                <span class="lab-third-card-text">{{ thirdCardText }}</span>
              </div>
            </div>
          </v-card>
        </div>
      </v-row>
      <v-row v-else>
        <v-img eager contain src="https://storage.googleapis.com/mwm-website-v2-content/rd/card-mixfader.jpg" />
        <v-row no-gutters justify="center">
          <v-col cols="11" align="center">
            <div class="lab-first-card-title-wrapper">
              <div class="lab-first-card-title">
                <span class="title-accent">{{ firstCardTitleAccent }}</span><br/>
                {{ firstCardTitle }}
              </div>
            </div>
            <div class="lab-card-quote-wrapper">
              <div>
                <img class="lab-card-quotemark quotemark-topleft" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                <span class="lab-card-quote">{{ firstCardQuote1Quote }}</span>
                <img class="lab-card-quotemark quotemark-botright" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
              </div>
              <div class="lab-card-quoter-wrapper"><span class="lab-card-quoter">{{ firstCardQuote1Quoter }}</span></div>
            </div>
            <div class="lab-card-quote-wrapper">
              <div>
                <img class="lab-card-quotemark quotemark-topleft" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                <span class="lab-card-quote">{{ firstCardQuote2Quote }}</span>
                <img class="lab-card-quotemark quotemark-botright" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
              </div>
              <div class="lab-card-quoter-wrapper"><span class="lab-card-quoter">{{ firstCardQuote2Quoter }}</span></div>
            </div>
            <div class="lab-card-button-wrapper">
              <v-btn height="54" :ripple="false" class="lab-card-button" @click="openUrl(firstCardURL)">
                <span class="lab-card-button-text">{{ cardButtonText }}</span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-img eager class="lab-card-image" contain src="https://storage.googleapis.com/mwm-website-v2-content/rd/card-phase.jpg" />
        <v-row no-gutters justify="center">
          <v-col cols="11" align="center">
            <div class="lab-second-card-title-wrapper">
              <div class="lab-second-card-title">
                <span class="title-accent">{{ secondCardTitleAccent }}</span><br/>
                {{ secondCardTitle }}
              </div>
            </div>
            <div class="lab-card-quote-wrapper">
              <div>
                <img class="lab-card-quotemark quotemark-topleft" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                <span class="lab-card-quote">{{ secondCardQuote1Quote }}</span>
                <img class="lab-card-quotemark quotemark-botright" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
              </div>
              <div class="lab-card-quoter-wrapper"><span class="lab-card-quoter">{{ secondCardQuote1Quoter }}</span></div>
            </div>
            <div class="lab-card-quote-wrapper">
              <div>
                <img class="lab-card-quotemark quotemark-topleft" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
                <span class="lab-card-quote">{{ secondCardQuote2Quote }}</span>
                <img class="lab-card-quotemark quotemark-botright" src="https://storage.googleapis.com/mwm-website-v2-content/quote.svg" >
              </div>
              <div class="lab-card-quoter-wrapper"><span class="lab-card-quoter">{{ secondCardQuote2Quoter }}</span></div>
            </div>
            <div class="lab-card-button-wrapper">
              <v-btn height="54" :ripple="false" class="lab-card-button" @click="openUrl(secondCardURL)">
                <span class="lab-card-button-text">{{ cardButtonText }}</span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-img eager class="lab-card-image" contain src="https://storage.googleapis.com/mwm-website-v2-content/rd/card-audio.jpg" />
        <v-row no-gutters justify="center">
          <v-col cols="9" align="center">
            <div class="lab-third-card-title-wrapper">
              <span class="lab-third-card-title">{{ thirdCardTitle }}</span>
            </div>
            <div class="lab-third-card-text-wrapper">
              <span class="lab-third-card-text">{{ thirdCardText }}</span>
            </div>
          </v-col>
        </v-row>
      </v-row>
      <div class="bottom-wrapper">

      </div>
    </v-col>
  </v-row>
</template>

<script>
import SizeHolder from '@/mixins/SizeHolder.vue';

import ImageRow from './components/ImageRow.vue'

export default {
  mixins: [SizeHolder],
  components: {
    'image-row': ImageRow,
  },
  data: () => ({
    topTitle: 'Creativity is limitless.<br/>So is our willpower.',

    labTitle: 'Our lab',
    labFirstText: 'Creativity should not have limit. We are committed to imagining innovative and affordable creation tools by dematerializing existing solutions, but we also know that the boundaries of creativity go far beyond the simple smartphone screen.',
    labSecondText: 'That’s why, at MWM, we invest a lot on hardware R&D. We can count on an independent team that has been in particular behind the release of two audio innovations that are today used by millions of users and famous DJs:',

    cardButtonText: 'Learn more',

    firstCardTitleAccent: 'Mixfader, the world’s first wireless crossfader,',
    firstCardTitle: 'that enables turntablists to mix with the lightest DJ equipment.',
    firstCardQuote1Quote: 'Excellent product, works perfectly, and, big plus... it’s French!',
    firstCardQuote1Quoter: 'Pierre M., Mixfader user',
    firstCardQuote2Quote: 'Best quality, robust and reliable, doesn’t slip. Would I buy it again? Of course I would!',
    firstCardQuote2Quoter: 'Nick B., Mixfader user',
    firstCardURL: 'https://mwm-store.com/mixfader',

    secondCardTitleAccent: 'Phase, an innovative DJ gear,',
    secondCardTitle: 'that allows DJ to get rid of the technical instabilities related to the use of turntable cartridge.',
    secondCardQuote1Quote: 'This in an absolute game changer.',
    secondCardQuote1Quoter: 'DJ Craze',
    secondCardQuote2Quote: 'The future is now. You invented tomorrow’s turntablism.',
    secondCardQuote2Quoter: 'DJ Jazzy Jeff',
    secondCardURL: 'https://mwm-store.com/phase',

    thirdCardTitle: 'We also count on Machine Learning R&D',
    thirdCardText: 'The Audio Signal Processing R&D division’s mission is to develop real-time audio technologies for MWM apps. The team builds cutting-edge algorithms for synthesis, analysis, and processing of sound and music, but also develops optimized implementations of these algorithms to offer innovative sound and music interaction to all smartphones users.',
  }),
  methods: {
    openUrl (url) {
      const win = window.open(url, '_blank');
      win.focus();
    },
  },
  computed: {

  },
  mounted () {

  }
};
</script>

<style scoped lang="scss">
@media (max-width: 960px) {
  .lab-wrapper {
    margin-top: 2rem;
    width: 75%!important;
  }

  .lab-content {
    padding-bottom: 4rem!important;
  }

  .lab-card-image {
    width: 80%!important;
  }
}

.lab-wrapper {
  display: table;
  width: 45%;
  height: 70vh;
  margin-right: auto;
  margin-left: auto;
}

.lab-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  padding-bottom: 8rem;
}

.lab-title-wrapper {

}

.lab-title {
  font-family: CenturyGothic;
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #212a39;
}

.lab-first-text-wrapper {
  margin-top: 4rem;
}

.lab-first-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: normal;
  text-align: center;
  color: #212a39;
}

.lab-second-text-wrapper {
  margin-top: 2rem;
}

.lab-second-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: normal;
  text-align: center;
  color: #212a39;
}

.lab-cards-wrapper-parent {
  position: relative;
  height: 2500px;
  width: 100%;
  background-image: -webkit-gradient(linear, left top, right top, color-stop(99%, #990cb4), color-stop(19%, #ff0067));
  background-image: linear-gradient(to right, #990cb4, #ff0067);
}

.lab-cards-wrapper-child {
  position: absolute;
}

.first-child {
  top: -7rem;
}

.second-child {
  top: 0rem;
}

.third-child {
  top: 7rem;
}

.lab-card {
  width: 766px;
  border-radius: 30px!important;
  text-align: center;
  padding-bottom: 3rem;
  box-shadow: 0 7px 28px 0 rgba(0, 0, 0, 0.13);
}

.lab-card-button-wrapper {
  margin-top: 2rem;
}

.lab-card-button {
  width: 200px;
  border-radius: 27px;
  background-image: -webkit-gradient(linear, left top, right top, color-stop(114%, #990cb4), color-stop(12%, #ff0067));
  background-image: linear-gradient(to right, #990cb4, #ff0067);
}

.lab-card-button-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  text-transform: none;
  color: #ffffff;
}

.lab-card-quote-wrapper {
  margin-top: 2rem;
}

.lab-card-quote {
  font-family: CenturyGothic;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: italic;
  line-height: 1.4;
  letter-spacing: normal;
  color: #212a39;
}

.lab-card-quoter-wrapper {
  margin-top: 0.2rem;
}

.lab-card-quoter {
  font-family: CenturyGothic;
  font-size: 14.4px;
  font-weight: bold;
  font-stretch: normal;
  font-style: italic;
  line-height: normal;
  letter-spacing: normal;
  color: #212a39;
}

.lab-card-quotemark {
  width: 24px;
  height: 18px;
  margin-left: 0.6rem;
  margin-right: 0.6rem;
}

.quotemark-topleft {

}

.quotemark-botright {
  transform: rotate(180deg);
}

.lab-card-image {
  margin-top: 4rem;
}

.lab-first-card-content-wrapper {
  width: 75%;
  margin: auto;
}

.lab-first-card-title-wrapper {
  margin-top: 3rem;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.lab-first-card-title {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #212a39;
}

.lab-first-card-title .title-accent {
  color: #ff0067;
}

.lab-second-card-title-wrapper {
  margin-top: 3rem;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.lab-second-card-title {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #212a39;
}

.lab-second-card-title .title-accent {
  color: #ff0067;
}

.lab-third-card-content-wrapper {
  width: 80%;
  margin: auto;
}

.lab-third-card-title-wrapper {
  margin-top: 3rem;
}

.lab-third-card-title {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #ff0067;
}

.lab-third-card-text-wrapper {
  margin-top: 2rem;
  text-align: justify;
  padding-bottom: 3rem;
}

.lab-third-card-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #212a39;
}

.bottom-wrapper {
  display: table;
  width: 100%;
  height: 30vh;
  margin-right: auto;
  margin-left: auto;
}

</style>
